var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "day-configurator-practical-details px-24 pt-24 pb-0 px-md-40 py-md-32"
    },
    [
      _c("div", { staticClass: "content-wrapper" }, [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c("ValidationObserver", {
              ref: "observer",
              attrs: { tag: "div", slim: true },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var invalid = ref.invalid
                    var errors = ref.errors
                    return [
                      _c("h2", { staticClass: "mb-24 mb-md-32" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.translations.practical_details.title) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "mb-16", attrs: { for: "date" } },
                        [
                          _vm._v(
                            _vm._s(_vm.translations.practical_details.date)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-16 font-weight-light" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.translations.practical_details
                                .date_description
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-40 mb-md-24" }, [
                        _c(
                          "div",
                          { staticClass: "date-wrapper mb-0" },
                          [
                            _c(
                              "ValidationProvider",
                              {
                                ref: "provider",
                                attrs: {
                                  vid: "date",
                                  name: "date",
                                  rules:
                                    _vm.schedule.date_object != null &&
                                    _vm.schedule.date_object.type === "unknown"
                                      ? ""
                                      : "required",
                                  tag: "div"
                                }
                              },
                              [
                                _c(
                                  "flat-pickr",
                                  _vm._g(
                                    {
                                      attrs: {
                                        allowInput: false,
                                        id: "date",
                                        name: "date",
                                        config: _vm.flatPickrConfig
                                      },
                                      model: {
                                        value: _vm.flatPickrDate,
                                        callback: function($$v) {
                                          _vm.flatPickrDate = $$v
                                        },
                                        expression: "flatPickrDate"
                                      }
                                    },
                                    Object.assign({}, _vm.$listeners, {
                                      input: _vm.dateUpdate
                                    })
                                  )
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.schedule.date_object != null &&
                        _vm.schedule.date_object.type !== "single"
                          ? _c("span", { staticClass: "d-inline-block mr-8" }, [
                              _vm._v(_vm._s(_vm.dateMode))
                            ])
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            staticClass: "text-accent font-weight-light",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showDatePopup()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.schedule.date_object == null ||
                                  _vm.schedule.date_object.type === "single"
                                  ? _vm.translations.practical_details
                                      .no_exact_date_label
                                  : _vm.translations.practical_details.modify
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "mb-16", attrs: { for: "location" } },
                        [
                          _vm._v(
                            _vm._s(_vm.translations.practical_details.location)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.items.location ||
                      !_vm.items.location.length ||
                      _vm.loadingGoogleLocation
                        ? _c(
                            "div",
                            { staticClass: "spinner-background visible mb-24" },
                            [_c("div", { staticClass: "spinner" })]
                          )
                        : [
                            _c(
                              "p",
                              { staticClass: "mb-16 font-weight-light" },
                              [
                                _vm._v(
                                  "\n                        Maak een keuze uit onze lijst met inspirerende\n                        locaties. Meer weten over de locaties? Klik dan\n                        "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.route("nl.locations"),
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("hier")]
                                ),
                                _vm._v(
                                  ". Liever ergens anders? Klik dan op 'Meer opties'.\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.location_type === "WORDPRESS"
                              ? _c(
                                  "ValidationProvider",
                                  {
                                    ref: "location",
                                    staticClass: "mb-24",
                                    attrs: {
                                      vid: "location",
                                      name:
                                        _vm.translations.practical_details
                                          .location,
                                      rules: "required",
                                      tag: "div"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        options: _vm.items.location.map(
                                          function(l) {
                                            return l.post_title
                                          }
                                        ),
                                        type: "select",
                                        rules: "required",
                                        name: "location",
                                        placeholder:
                                          _vm.translations.practical_details
                                            .location_choose,
                                        vid: "location"
                                      },
                                      model: {
                                        value: _vm.location,
                                        callback: function($$v) {
                                          _vm.location = $$v
                                        },
                                        expression: "location"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.location_type === "GOOGLE_MAPS"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex mb-8" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "location",
                                        staticClass: "w-100",
                                        attrs: {
                                          vid: "location",
                                          name:
                                            _vm.translations.practical_details
                                              .location,
                                          rules: "required",
                                          tag: "div"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var classes = ref.classes
                                              return [
                                                _c("vue-google-autocomplete", {
                                                  ref: "locationAutocomplete",
                                                  class: classes,
                                                  attrs: {
                                                    id: "location",
                                                    name: "location",
                                                    types: "",
                                                    placeholder:
                                                      _vm.translations
                                                        .practical_details
                                                        .location_choose,
                                                    country: ["be"]
                                                  },
                                                  on: {
                                                    placechanged:
                                                      _vm.getAddressData,
                                                    blur: _vm.validateAddress,
                                                    change: _vm.validateAddress
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ])
                                      }),
                                      _vm._v(" "),
                                      _c("ValidationProvider", {
                                        ref: "range",
                                        attrs: {
                                          vid: "range",
                                          name:
                                            _vm.translations.practical_details
                                              .location_range,
                                          rules: "integer|min:1|max:300",
                                          tag: "div"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var classes = ref.classes
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.radius,
                                                      expression: "radius"
                                                    }
                                                  ],
                                                  staticClass: "ml-16",
                                                  class: classes,
                                                  attrs: {
                                                    type: "number",
                                                    id: "range",
                                                    name:
                                                      _vm.translations
                                                        .practical_details
                                                        .location_range,
                                                    min: "1",
                                                    max: "300",
                                                    placeholder:
                                                      _vm.translations
                                                        .practical_details
                                                        .location_range
                                                  },
                                                  domProps: {
                                                    value: _vm.radius
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.radius =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ])
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "kilometers ml-8 font-weight-light"
                                        },
                                        [_vm._v("km")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  (errors.location != null &&
                                    errors.location.length > 0) ||
                                  (errors.range != null &&
                                    errors.range.length > 0)
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "error small d-block mb-24"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              errors.location[0] ||
                                                errors.range[0]
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "d-inline-block text-accent font-weight-light mb-24",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.showLocationPopup()
                                  }
                                }
                              },
                              [_vm._v("Meer opties")]
                            )
                          ],
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                          class:
                            errors.amount_of_persons != null &&
                            errors.amount_of_persons.length > 0
                              ? "mb-8"
                              : "mb-32"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column w-100" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "mb-8",
                                  attrs: { for: "amount_of_persons" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.practical_details
                                        .amount_of_persons
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "text-accent font-weight-light",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.showParticipantsPopup()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.attendee_object.type === "exact"
                                        ? _vm.translations.practical_details
                                            .amount_of_persons_unknown
                                        : _vm.translations.practical_details
                                            .modify
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.attendee_object.type === "exact"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "number-wrapper d-flex align-items-center"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "decrease mr-16",
                                      on: { click: _vm.decreaseParticipants }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "10",
                                            height: "10"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              fill: "#efefef",
                                              d:
                                                "M5 10A5 5 0 105 0a5 5 0 000 10z"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M7.1 4.6a.4.4 0 01.08.792L7.1 5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6z"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ValidationProvider",
                                    {
                                      ref: "provider",
                                      staticClass: "w-100",
                                      attrs: {
                                        vid: "amount_of_persons",
                                        name:
                                          _vm.translations.practical_details
                                            .amount_of_persons,
                                        rules:
                                          _vm.attendee_object.type === "exact"
                                            ? "required|integer|min:1"
                                            : "",
                                        tag: "div"
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.attendee_object.data.amount,
                                            expression:
                                              "attendee_object.data.amount"
                                          }
                                        ],
                                        staticClass: "text-center",
                                        attrs: {
                                          type: "number",
                                          id: "amount_of_persons",
                                          min: "1",
                                          name: "amount_of_persons"
                                        },
                                        domProps: {
                                          value: _vm.attendee_object.data.amount
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.attendee_object.data,
                                              "amount",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "increase ml-16",
                                      on: { click: _vm.increaseParticipants }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "10",
                                            height: "10"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              fill: "#efefef",
                                              d:
                                                "M5 10A5 5 0 105 0a5 5 0 000 10z"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M5 2.5a.4.4 0 01.392.32l.008.08v1.7h1.7a.4.4 0 01.08.792L7.1 5.4H5.4v1.7a.4.4 0 01-.792.08L4.6 7.1V5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6h1.7V2.9c0-.22.18-.4.4-.4z"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c("div", [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.attendee_object.data.min +
                                        "‑" +
                                        _vm.attendee_object.data.max +
                                        (_vm.attendee_object.data.max == 300
                                          ? "+"
                                          : "") +
                                        " " +
                                        _vm.translations.practical_details
                                          .persons
                                    )
                                  )
                                ])
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      errors.amount_of_persons != null &&
                      errors.amount_of_persons.length > 0
                        ? _c(
                            "span",
                            { staticClass: "error small d-block mb-24" },
                            [_vm._v(_vm._s(errors.amount_of_persons[0]))]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }